(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nutrex-quality"] && !window.DesignMode) return;
  try {
    
var swiper = new Swiper('.quality-swiper-container', {
  slidesPerView: 2,
  spaceBetween: 15,
  /*pagination: {
    el: '.quality-swiper-container .swiper-pagination',
    clickable: true,
  },*/
  loop: true,
  autoplay: {
    delay: 3000,
  },
});

  } catch(e) { console.error(e); }
})();
})();
